import { useCallback, useState } from 'react';
import { Text } from '@/components/Text';
import { useDashboardContext } from '@/contexts/DashboardContext/useDashboardContext';
import { Modal } from '@/components/ui/therapist/Modal';
import { Button } from '@/components/ui/therapist/Button';
import { SetType } from '@/stores/store.types';
import { Pill } from '@/components/Pill';
import { CopyModal } from './CopyModal';
import { DeleteModal } from './DeleteModal';
import { IconName } from '@/components/NeolexonIcon/Icons/types';
import { SetCardMenu } from './SetCardMenu';
import { CardTemplate } from '@/components/CardTemplate';
import { IS_IOS } from '@/utils/platform';

const iconMap = {
  Wörtersets: 'letter',
  Sätzesets: 'sentence',
  Textesets: 'reading',
};

const singularMap = {
  Wörtersets: 'Wörterset',
  Sätzesets: 'Sätzeset',
  Textesets: 'Texteset',
};

type SetCardProps = {
  data: any;
  type: SetType;
  patientID: string;
  fetchPatientsWrapper: () => void;
  selectedPatientFullName: string;
  refreshPatient: () => void;
};

export const SetCard = ({
  data,
  type,
  patientID,
  fetchPatientsWrapper,
  selectedPatientFullName,
  refreshPatient,
}: SetCardProps) => {
  const nameSliceCheck = IS_IOS ? 15 : 20;
  const { selectedID } = useDashboardContext();
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    isSetActive: false,
  });

  const { name, _id, appDisplayName } = data ?? {};

  const [showCopyModal, setShowCopyModal] = useState(false);
  const [infoCopyModal, setInfoCopyModal] = useState({
    title: '',
    idOfDataSet: '',
    type: '',
  });
  const [showCopyErrorModal, setShowCopyErrorModal] = useState(false);
  const [localSelectedPatientID, setLocalSelectedPatientID] =
    useState(selectedID);

  const hideCopyModal = useCallback(() => {
    setShowCopyModal(false);
  }, []);

  return (
    <>
      <DeleteModal
        data={data}
        deleteModal={deleteModal}
        fetchPatientsWrapper={fetchPatientsWrapper}
        patientID={patientID}
        refreshPatient={refreshPatient}
        selectedPatientFullName={selectedPatientFullName}
        setDeleteModal={setDeleteModal}
        type={type}
      />
      <CardTemplate
        footerSection={() => (
          <SetCardMenu
            appDisplayName={appDisplayName}
            exerciseSetName={name}
            id={_id}
            setDeleteModal={setDeleteModal}
            setInfoCopyModal={setInfoCopyModal}
            setShowCopyModal={setShowCopyModal}
            type={type}
          />
        )}
        name={
          name.length > nameSliceCheck
            ? name.slice(0, nameSliceCheck) + '...'
            : name
        }
        pillsSection={() => (
          <Pill
            label={singularMap[type]}
            icon={iconMap[type] as IconName}
            isNeolexon={false}
            iconSize={22}
          />
        )}
      />
      <CopyModal
        hideCopyModal={hideCopyModal}
        infoCopyModal={infoCopyModal}
        localSelectedPatientID={localSelectedPatientID}
        refreshPatient={refreshPatient}
        setInfoCopyModal={setInfoCopyModal}
        setLocalSelectedPatientID={setLocalSelectedPatientID}
        setShowCopyErrorModal={setShowCopyErrorModal}
        setShowCopyModal={setShowCopyModal}
        showCopyModal={showCopyModal}
      />
      <Modal
        onClose={() => setShowCopyErrorModal(false)}
        isVisible={showCopyErrorModal}
        confirmActionButton={
          <Button label="OK" onPress={() => setShowCopyErrorModal(false)} />
        }
        title="Fehler beim Kopieren"
      >
        <Text></Text>
      </Modal>
    </>
  );
};
